import { Army } from "@/domain/army";
import { useEnsureShareLink } from "@/ui/hooks/use-ensure-share-link";
import { ShareDialog } from "@/ui/share-dialog";
import { DialogStore } from "@ariakit/react";

export function ShareArmyDialog(props: { armyShareTitle: string; army: Army; store: DialogStore }) {
  const shareLinkOp = useEnsureShareLink(props.army.data);

  const linkValue = shareLinkOp.val ?? "Generating unique link...";

  const shareData = shareLinkOp
    .mapSuccess((url) => ({ title: props.armyShareTitle, url }))
    .valueOrNull();

  // Reads better than referending 'Unnamed Army'
  const armyName = props.army.data.name || `this ${props.army.shortTypeLabel.toLowerCase()}`;

  return (
    <ShareDialog
      store={props.store}
      heading={`Share ${props.army.shortTypeLabel}`}
      inputValue={linkValue}
      shareData={shareData}
      text={`Share this version of ${armyName} with your friends and enemies! If you make changes, you will need to generate a new link for others to see them.`}
    />
  );
}
